import type { Assignment } from "~/classes/models/assignments/assignment.model";
import type { SubmittedDocument } from "~/types/SubmittedDocument";
import { AssignmentType } from "~/types/enums/AssignmentType.enum";
import { DocumentSubmissionType } from "~/types/enums/DocumentSubmissionType.enum";

export const isAssignmentReferenceChecklistDraft = (
  submittedDocument?: Pick<
    SubmittedDocument,
    | "assignmentRequireRoughDraftChecklist"
    | "assignmentType"
    | "documentSubmissionType"
  >
) =>
  submittedDocument?.documentSubmissionType ===
    DocumentSubmissionType.roughDraft &&
  submittedDocument.assignmentRequireRoughDraftChecklist === false &&
  submittedDocument.assignmentType !== AssignmentType.general;

export const resolveAssignmentReferenceChecklist = (
  assignment: Pick<
    Assignment,
    "checklistId" | "checklistPath" | "studentChecklistOverrides" | "type"
  >,
  studentId?: string
) => {
  if (assignment.type === AssignmentType.general) return undefined;

  const override = assignment.studentChecklistOverrides?.find(
    (candidate) =>
      studentId != undefined && candidate.studentIds.includes(studentId)
  );
  const checklistId = override?.checklistId || assignment.checklistId;

  if (!checklistId) return undefined;

  return {
    checklistId,
    checklistPath:
      override?.checklistPath || assignment.checklistPath || "/checklists",
  };
};
